module.exports = __webpack_public_path__ + "img/K2.16c156b0.gif";